<div class="app-site-nav">
    @for (link of links; track link) {
        <a class="app-site-nav__item" [routerLink]="link.path" routerLinkActive="app-site-nav__item--active">
            {{ link.label }}
        </a>
    }
</div>
